export default () => {
  return {
    definitions: [
      {
        id: 'mark',
        label: '标注',
        icon: 'mark',
        buttons: [
          {
            id: 'freehand',
            label: '多边形标注',
            icon: 'mark',
            type: 'setToolActive',
            commandName: 'markTool',
            commandOptions: { toolName: 'MarkFreehandRoi' },
          },
          {
            id: 'rect',
            label: '矩形标注',
            icon: 'square-o',
            type: 'setToolActive',
            commandName: 'markTool',
            commandOptions: { toolName: 'MarkRectangleRoi' },
          },
        ],
      },
    ],
    defaultContext: 'ACTIVE_VIEWPORT::CORNERSTONE',
  };
};
